import { Directive, Input, ViewContainerRef } from '@angular/core';
import { CheckIconComponent, CrossIconComponent } from '../components';

@Directive({
    selector: '[showCheckOrCrossIcon]',
    standalone: false
})
export class ShowCheckOrCrossIconDirective {
  @Input() set showCheckOrCrossIcon(isVisible: boolean) {
    this.viewContainer.clear();

    if (isVisible) {
      this.viewContainer.createComponent(CheckIconComponent);
    } else {
      this.viewContainer.createComponent(CrossIconComponent);
    }
  }

  constructor(private viewContainer: ViewContainerRef) {}
}
